// Shop block schema - Display products for sale
export const shopSchema = {
  type: 'shop',
  label: 'Shop',
  description: 'Display your products for sale',
  icon: 'Store',
  defaultContent: {
    heading: 'Shop',
    showPrices: true,
    maxProducts: 6,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Shop' },
    { name: 'maxProducts', label: 'Max Products', type: 'number' },
  ],
};
